import Vue from 'vue';

Vue.filter('fix_model_name', function (value) {
	return value?.replace("_", " ");
});
